export const isStatelessComponent = (Component) =>
  !(Component.prototype && Component.prototype.render);
